import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { LenderChannel } from '../tokens/lender-risk-rules.token';
import {
  Concentration,
  ExposureLimitUpdate,
  ExposureLimitsConfig,
  LenderExposureApi,
} from '../tokens/lender-exposure.token';

/**
 * REST-only implementation of {@link LenderExposureApi} (EM-699 / F2 — EM-707).
 *
 * Calls the story-B3 backend (EM-702) `/api/v1/exposure/**` surface through the
 * gateway. The E-D Partner Limits table is composed by the component from the
 * per-channel {@code GET /exposure/limits/{channel}} (one call per channel). The
 * concentration cards consume {@code GET /exposure/concentration}. REST-only per
 * Rules 07/10; rides the Keycloak bearer. A save with a null amount → 400
 * AMOUNT_REQUIRED, surfaced via `extractBackendErrorMessage` (Rule 09).
 */
@Injectable()
export class LenderExposureRestService implements LenderExposureApi {
  private readonly http = inject(HttpClient);

  getLimits(channel: LenderChannel): Observable<ExposureLimitsConfig> {
    return this.http.get<ExposureLimitsConfig>(`${API_PATHS.EXPOSURE_LIMITS}/${channel}`);
  }

  saveLimit(channel: LenderChannel, update: ExposureLimitUpdate): Observable<ExposureLimitsConfig> {
    return this.http.put<ExposureLimitsConfig>(`${API_PATHS.EXPOSURE_LIMITS}/${channel}`, update);
  }

  getConcentration(): Observable<Concentration> {
    return this.http.get<Concentration>(API_PATHS.EXPOSURE_CONCENTRATION);
  }
}
